export default {"src":"/_next/static/media/TMO.d8168d73.svg","height":18,"width":18};